import React from 'react';
import PropTypes from 'prop-types';
import {  SelectList, Icon, Loader } from 'components';
import { useSelect } from 'hooks';


const ContainerServiceOptions = ({ onSelect }) => {
  // const getList = useAction('transaction.getList');
  const list = useSelect('transaction.list');
  const isLoading = useSelect('loading.isLoading', { type: 'transaction.getList' });
  
  // useEffect(() => {
  //   getList()
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const handleSelect = selected => {
    onSelect(selected)
  }

  return (
    <div className="flex flex-col">
      <div className="inline-flex space-x-2 items-center justify-center">
        <Icon.Transaction className="!text-primary"/>
        <b className="text-lg xl:text-3xl lg:text-2xl font-medium">Select Transaction</b>
      </div>
      <div className="flex my-10">
        {isLoading ? <Loader.Table /> : <SelectList data={list} onSelect={handleSelect}/>}
      </div>
    </div>
  )
}

ContainerServiceOptions.defaultProps = {
  onSelect: () => {}
}

ContainerServiceOptions.propTypes = {
  onSelect: PropTypes.instanceOf(Function)
}

export default ContainerServiceOptions